<template>
  <div class="page">
      <public-head title="真题详情"></public-head>
      <div class="main" v-if="detailtList.title!=undefined">
        <div class="title">
            {{ detailtList.title}}
        </div>
        <div class="content">
                <p v-html="detailtList.content"></p>
         </div>
     </div>
     <div v-else class="_noPost">
       <img src="https://new.schoolpi.net/attach/small_program/index/no-data.png" class="no-data"/>
    </div>
  </div>
</template>

<script>
    import PublicHead from "../../../components/publicHead";
    import { httpPost } from "../../../axios/index";
export default {
   
    data() {
        return {
             detailtList:{}
        };
    },
    created() {},
    methods: {
       
        //获取报考政策详情数据
        fetchDetailList(id) {
            httpPost("/classifie/question_details", {
                id: id
            }).then(res => {
               
                if (res.code === 1) {
                    this.detailtList = res.list;
                } 
            })
        }
    },
    mounted() {
        this. fetchDetailList(this.$route.query.id);
    },
    components: {
        PublicHead
    }
};
</script>
    
<style scoped>
.page{
    /* width: 100%;
    height: 100%;
    background: #f2f2f2; */
}
    .main{
    margin-top: 46px;
    width: 100%;
    height: 100%;
    padding: 1.25rem 0.9375rem;
   box-sizing: border-box;
}
.title{
    font-size: 1.125rem;
    font-weight: bold;
     text-align: center;
}
.content{
    margin-top:1.25rem; 
}
._noPost{
    text-align: center;
   position: relative;
}
.no-data{
    width: 6.25rem;
    height: 7.1875rem;
    position: absolute;
    top: 10.9375rem;
    left: 0;
    right: 0;
    margin: auto;
}

</style>